/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import * as React from 'react';
export const LabelerStoreContext = React.createContext(null);
export const useLabelerStore = () => React.useContext(LabelerStoreContext);
